<template>
    <Divider layout="vertical"/>
    <div class="d-inline-block">
        <div class="d-flex align-items-center">
            <label for="colspan" class="me-2">Colspan:</label>
            <InputNumber :disabled="!canApplyColspan" style="width: 80px;" :showButtons="true" :fluid="true" :min=1 :max="getMaxColSpan()" v-model.number="localSettings.colspan" @input="updateSettings"/>
        </div>
    </div>

    <Divider layout="vertical"/>
    <div class="d-inline-block mx-1">
        <ToggleButton :disabled="!canApplyPercentage" v-model="localSettings.isPercentage" onLabel="%" offLabel="%" @change="updateSettings"/>
    </div>
    <div class="d-inline-block mx-1">
        <div class="d-flex align-items-center">
            <label for="decimalPlaces" class="mx-2">Decimals:</label>
            <Dropdown
                :disabled="!canApplyDecimalPlaces"
                v-model="localSettings.decimalPlaces"
                :options="decimalOptions"
                optionLabel="name"
                optionValue="value"
                style="width: 100px;"
                @change="updateSettings"
                :panelStyle="{'width': '200px'}"               
            />
        </div>
    </div>
    <!--
    NOTE: Format settings for date, currently not used
    <div class="d-inline-block mx-1">
        <div class="d-flex align-items-center">
            <label for="format" class="mx-2">Format:</label>
            <Dropdown
                :disabled="!canApplyFormat"
                v-model="localSettings.format"
                :options="formatOptions"
                optionLabel="name"
                optionValue="value"
                style="width: 100px;"
                @change="updateSettings"
                :panelStyle="{'width': '150px'}"
            />
        </div>
    </div>
    -->
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        emits: ['update-settings-event'],
        props: {
            styleComponent: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                localSettings: { ...(this.styleComponent.settings || {}) },
                decimalOptions: [
                    {name: 'Auto', value: 'auto' },
                    {name: "0 Decimal Place", value: 0},
                    {name: "1 Decimal Place", value: 1},
                    {name: "2 Decimal Places", value: 2},
                    {name: "3 Decimal Places", value: 3},
                    {name: "4 Decimal Places", value: 4}
                ],
                // formatOptions: this.styleComponent.component == 'DATETIME' ? 
                // [
                //     { name: 'dd/MM/yyyy', value: 'dd/MM/yyyy' },
                //     { name: 'MM/dd/yyyy', value: 'MM/dd/yyyy' },
                //     { name: 'dd-MM-yyyy', value: 'dd-MM-yyyy' },
                //     { name: 'MM-dd-yyyy', value: 'MM-dd-yyyy' },
                //     { name: 'yyyy-MM-dd', value: 'yyyy-MM-dd' },
                //     { name: 'yyyy/MM/dd', value: 'yyyy/MM/dd' }
                // ] :
                // []
            };
        },
        watch: {
            styleComponentRowColumnIndex: {
                immediate: true,
                handler() {
                    this.localSettings = { ...(this.styleComponent.settings || {}) };
                },
            },
        },
        computed: {
            canApplyColspan() {
                return ['LONGLABEL', 'LONGTEXT'].includes(this.styleComponent.component);
            },
            canApplyPercentage() {
                return ['NUMBER', 'VALUE', 'FORMULA'].includes(this.styleComponent.component);
            },
            canApplyDecimalPlaces() {
                return ['NUMBER', 'VALUE', 'FORMULA'].includes(this.styleComponent.component);
            },
            // canApplyFormat() {
            //     return ['DATETIME'].includes(this.styleComponent.component);
            // },
            styleComponentRowColumnIndex() {
                return [this.styleComponent.rowIndex, this.styleComponent.columnIndex];
            }
        },
        methods: {
            updateSettings() {
                this.$emit('update-settings-event', this.localSettings);
            },
            getMaxColSpan() {
                const sheetInfo = this.styleComponent.sheetInfo;
                let next = null;
                let i = sheetInfo.columnIndex + 1;
                while (i < sheetInfo.numCols && next == null) {
                    
                    if (sheetInfo.template[sheetInfo.rowIndex].columns[i].component != null) {
                        next = sheetInfo.template[sheetInfo.rowIndex].columns[i];
                    }
                    i++;
                }
                if (next == null) {
                    return sheetInfo.numCols - sheetInfo.columnIndex;
                } else {
                    return i - 1 - sheetInfo.columnIndex;
                }
            }
        },
    });
</script>